import { render, staticRenderFns } from "./SelectInsurers.vue?vue&type=template&id=be901d80&scoped=true"
import script from "./SelectInsurers.vue?vue&type=script&lang=js"
export * from "./SelectInsurers.vue?vue&type=script&lang=js"
import style0 from "./SelectInsurers.vue?vue&type=style&index=0&id=be901d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be901d80",
  null
  
)

export default component.exports